module.exports = __webpack_public_path__ + "images/video_surround.png";